"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var axios_1 = __importDefault(require("axios"));
var react_responsive_modal_1 = __importDefault(require("react-responsive-modal"));
var date_fns_1 = require("date-fns");
var use_local_storage_1 = require("@hikakaku/shared/hooks/use_local_storage");
var title_webp_1 = __importDefault(require("images/users/opt_in_modal/title.webp"));
var main_webp_1 = __importDefault(require("images/users/opt_in_modal/main.webp"));
var LOCAL_STORAGE_KEY = 'user_opt_in_modal_opened_at_storage_key';
var OPT_IN_PATH = '/api/users/opt_in';
var OPT_OUT_PATH = '/api/users/opt_out';
var ISO_DATETIME_FORMAT = "yyyy-MM-dd'T'HH:mm:ssXXX";
var OptInModal = function () {
    var _a = (0, use_local_storage_1.useLocalStorage)(LOCAL_STORAGE_KEY), modalOpenedAt = _a[0], setModalOpenedAt = _a[1];
    var _b = react_1.default.useState(!modalOpenedAt), open = _b[0], setOpen = _b[1];
    var handleClose = react_1.default.useCallback(function () {
        setModalOpenedAt((0, date_fns_1.format)(new Date(), ISO_DATETIME_FORMAT));
        setOpen(false);
    }, []);
    var handleClickOptIn = react_1.default.useCallback(function () {
        axios_1.default.post(OPT_IN_PATH).finally(function () {
            setOpen(false);
        });
    }, []);
    var handleClickOptOut = react_1.default.useCallback(function () {
        axios_1.default.delete(OPT_OUT_PATH).finally(function () {
            setOpen(false);
        });
    }, []);
    return (react_1.default.createElement(react_responsive_modal_1.default, { open: open, onClose: handleClose, classNames: { modal: 'coUsersOptInModal-Container' } },
        react_1.default.createElement("div", { className: "coUsersOptInModal-ContentWrapper" },
            react_1.default.createElement("img", { src: title_webp_1.default, alt: "\u30E1\u30FC\u30EB\u30DE\u30AC\u30B8\u30F3\u306E\u914D\u4FE1", className: "coUsersOptInModal-ContentImage lazyload" }),
            react_1.default.createElement("img", { src: main_webp_1.default, alt: "\u30AD\u30E3\u30F3\u30DA\u30FC\u30F3\u60C5\u5831\u306A\u3069\u898B\u9003\u3055\u306A\u3044\u3088\u3046\u306B\uFF01", className: "coUsersOptInModal-ContentImage lazyload" })),
        react_1.default.createElement("div", { className: "coUsersOptInModal-ButtonWrapper" },
            react_1.default.createElement("button", { onClick: handleClickOptIn, className: "sw-Button sw-Button-controlMain coUsersOptInModal-Button" }, "\u5E0C\u671B\u3059\u308B"),
            react_1.default.createElement("button", { onClick: handleClickOptOut, className: "sw-Button sw-Button-default coUsersOptInModal-Button" }, "\u5E0C\u671B\u3057\u306A\u3044"))));
};
exports.default = OptInModal;
